import Builder from '@app/store/builder.ts';
const STATE = Builder.state({
    items: window.NAVIGATIONS
        ? (window.NAVIGATIONS['main'] || [])
        : [],
    isOpen: false,
}, 'Navigation');
const MUTATIONS = {
    setOpenState(open) {
        if (open) {
            document.body.classList.add('js-active');
        }
        else {
            document.body.classList.remove('js-active');
        }
        STATE.isOpen = open;
    },
    setItems(items) {
        STATE.items = items;
    },
};
const ACTIONS = {
    open() {
        MUTATIONS.setOpenState(true);
    },
    close() {
        MUTATIONS.setOpenState(false);
    },
    toggle() {
        MUTATIONS.setOpenState(!STATE.isOpen);
    }
};
export default {
    STATE,
    MUTATIONS,
    ACTIONS
};
